export default "__VITE_ASSET__76eef3fc__"